import { createSlice } from '@reduxjs/toolkit'

import { RequestStatus } from 'clickNgo/configs/service/common'

import { requestP360PartnerFlags } from './api/requestP360PartnerFlags'
import { PARTNER360_PARTNER_FLAGS_NAMESPACE } from './constants'
import { initialState } from './сonfigs'

const p360PartnerFlagsSlice = createSlice({
  name: PARTNER360_PARTNER_FLAGS_NAMESPACE,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(requestP360PartnerFlags.rejected, (state) => {
        state.requestStatus = RequestStatus.REJECTED
      })

      .addCase(requestP360PartnerFlags.pending, (state) => {
        state.requestStatus = RequestStatus.PENDING
      })
      .addCase(requestP360PartnerFlags.fulfilled, (state, action) => {
        state.requestStatus = RequestStatus.FULFILLED
        state.data = action.payload
      })
  },
})

export default p360PartnerFlagsSlice.reducer
